<script>
	// Generic db "tank" card. Renders one tank block from GET db/metrics:
	// { id, label, color, status?, columns: ["Public", "Private"],
	//   metrics: [{label, sublabel?, values: [pub, priv], format}] }
	// sublabel is optional: a unix timestamp (rendered as a date) or a
	// string passed through as-is, shown smaller under the label.
	// Two-column matrix inside a cylinder. No fill/completeness model.
	// No per-tank logic lives here; tank changes are backend-only.
	export let tank;

	$: comingSoon = tank.status === 'coming_soon';

	function formatValue(value, format) {
		if (value === null || value === undefined) return '—';
		if (format === 'datetime') {
			return new Date(value * 1000).toLocaleDateString('en-US', {
				month: 'numeric', day: 'numeric', year: 'numeric'
			});
		}
		if (format === 'int') {
			return value.toLocaleString('en-US');
		}
		return value;
	}
</script>

<!-- Cylinder tank - constrained on mobile so it doesn't stretch flat -->
<!-- Height fits the tallest tank (Records db: 7 metric rows) -->
<div class="relative w-full {comingSoon ? 'opacity-60' : ''}" style="height: 18rem; max-width: 23rem; margin: 0 auto;">
	<svg viewBox="0 0 240 300" preserveAspectRatio="none" class="absolute inset-0 w-full h-full">
		<path d="M 8 24 L 8 276 A 112 20 0 0 0 232 276 L 232 24"
			fill={comingSoon ? '#f3f4f6' : 'white'} stroke="#9ca3af" stroke-width="2.5"/>
		<ellipse cx="120" cy="24" rx="112" ry="20"
			fill={comingSoon ? '#e5e7eb' : '#f9fafb'} stroke="#9ca3af" stroke-width="2.5"/>
	</svg>
	<div class="absolute inset-0 flex flex-col px-6 pt-12 pb-5">
		<p class="text-base font-semibold text-center mb-0.5" style="color: {comingSoon ? '#6b7280' : tank.color};">
			{tank.label}
		</p>
		{#if comingSoon}
			<p class="text-xs text-gray-500 italic text-center mb-1">Coming soon</p>
		{/if}
		<table class="w-full text-sm text-gray-800">
			<thead>
				<tr>
					<th class="text-left font-semibold text-gray-600 pb-0.5"></th>
					{#each tank.columns as column}
						<th class="text-right font-semibold text-gray-600 pb-0.5">{column}</th>
					{/each}
				</tr>
			</thead>
			<tbody>
				{#each tank.metrics as metric}
					<tr>
						<td class="py-px pr-2">
							{metric.label}
							{#if metric.sublabel !== undefined && metric.sublabel !== null}
								<span class="text-xs text-gray-500 ml-1">
									{typeof metric.sublabel === 'number' ? formatValue(metric.sublabel, 'datetime') : metric.sublabel}
								</span>
							{/if}
						</td>
						{#each metric.values as value}
							<td class="py-px pl-2 text-right font-mono">{comingSoon ? '' : formatValue(value, metric.format)}</td>
						{/each}
					</tr>
				{/each}
			</tbody>
		</table>
	</div>
</div>
